<app-apply-shell [previousRoute]="previousRoute" [previousLabel]="previousLabel" [permitLabel]="title" [showForm]="!result" [outcome]="outcomeLine">
    @if (!result) {
        <app-closure-notice></app-closure-notice>
        <!-- The finder already asked which of the two routes applies, so only that one is
         explained. Opened directly, with no answer to go on, both are shown as before. -->
        @if (!holder) {
            <p class="text-muted">
                A {{ title }} is always tied to another permit, so you can't apply for one by itself. <strong>Short-term visitors</strong> {{ verb }} under a
                host, so you'll need your host's annual {{ type }} permit number. <strong>If you live and work here</strong>, you can apply for your own annual
                permit once you hold a valid work permit. Start by looking up the relevant permit number below.
            </p>
        }
        <div class="card border-0 shadow-sm mb-4">
            <div class="card-body">
                <h2 class="h6 mt-0">{{ lookupHeading }}</h2>
                @if (holder) {
                    <p class="text-muted small mb-2">{{ lookupPrompt }}</p>
                } @else {
                    <p class="text-muted small mb-2">
                        <strong>Short-term visitor under a host?</strong> Enter their annual {{ type }} permit number and the email address it was issued to, to
                        see the {{ areaWordPlural }} you can {{ verb }} in.<br />
                        <strong>Applying for an annual permit?</strong> Enter your <strong>work permit</strong> number and your own email address, to check
                        you're eligible.
                    </p>
                }
                <div class="d-flex gap-2 align-items-start flex-wrap">
                    <input
                        type="text"
                        class="form-control"
                        style="max-width: 240px"
                        [placeholder]="lookupPlaceholder"
                        [(ngModel)]="hostNumber"
                        (keyup.enter)="lookupHost()"
                    />
                    <!-- The number alone no longer resolves: the address it was issued to is
                     required too, so the register cannot be walked by counting. -->
                    <input
                        type="email"
                        class="form-control"
                        style="max-width: 280px"
                        [placeholder]="lookupEmailPlaceholder"
                        [(ngModel)]="hostEmail"
                        (keyup.enter)="lookupHost()"
                        autocomplete="off"
                    />
                    <button
                        type="button"
                        class="btn btn-outline-secondary"
                        (click)="lookupHost()"
                        [disabled]="lookingUp || !hostNumber.trim() || !hostEmail.trim()"
                    >
                        {{ lookingUp ? 'Looking up…' : 'Look up' }}
                    </button>
                </div>
                @if (lookupError) {
                    <div class="text-danger small mt-2">{{ lookupError }}</div>
                }
                @if (lookupResult) {
                    @if (!lookupResult.found) {
                        <div class="alert alert-warning mt-3 mb-0">
                            We couldn't match that permit number to that email address. Check both - the number, and the address the permit was issued to.
                        </div>
                    } @else if (lookupResult.type === 'fishing' || lookupResult.type === 'hunting') {
                        @if (lookupResult.clanAreas?.length) {
                            <div class="alert alert-success mt-3 mb-0">
                                <strong>{{ lookupResult.permitNumber }}</strong> ({{ lookupResult.permitType }},
                                {{ lookupResult.statusLabel || lookupResult.status }}) is approved for: <strong>{{ lookupResult.clanAreas?.join(', ') }}</strong
                                >. A short-term (14-day) visitor can {{ verb }} in these {{ areaWordPlural }}.
                            </div>
                        } @else {
                            <div class="alert alert-warning mt-3 mb-0">
                                {{ lookupResult.permitNumber }} is {{ lookupResult.permitType }}, but it has no approved {{ areaWordPlural }} yet.
                            </div>
                        }
                    } @else if (lookupResult.type === 'work') {
                        @if (lookupResult.active) {
                            <div class="alert alert-success mt-3 mb-0">
                                <strong>{{ lookupResult.permitNumber }}</strong> is an active Work Permit - you're <strong>eligible</strong> to apply for an
                                annual {{ type }} permit.
                            </div>
                        } @else {
                            <div class="alert alert-warning mt-3 mb-0">
                                {{ lookupResult.permitNumber }} is a Work Permit but it isn't active, so it can't be used for eligibility.
                            </div>
                        }
                    } @else {
                        <div class="alert alert-warning mt-3 mb-0">
                            {{ lookupResult.permitNumber }} is a {{ lookupResult.permitType }} - enter a fishing/hunting permit (to borrow a host's areas) or a
                            work permit (for annual eligibility).
                        </div>
                    }
                }
            </div>
        </div>

        @if (canProceed) {
            <ngxh6-form-embed
                [formOpts]="formOpts"
                [model]="formModel"
                [options]="{ sticky_actions: false, reload_on_save: false, show_delete: false, show_archive: false }"
                (submitted)="onSubmitted($event)"
            ></ngxh6-form-embed>
        } @else {
            <p class="text-muted mb-0">{{ lookupNudge }}</p>
        }
    } @else {
        <app-permit-result state="pending" [email]="result.email" [partySize]="result.partySize" [body]="result.submitMessage">
            <a class="btn btn-primary ms-0" [routerLink]="['/permit', result.token]">Check application status</a>
        </app-permit-result>
    }
</app-apply-shell>
